import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiCheck } from 'react-icons/fi';
import './ServiceFeatures.css';

const ServiceFeatures = ({ features, title }) => {
  const { t } = useTranslation();
  return (
    <section className="service-details-section service-features-section">
      <div className="service-features-heading">
        <h3 className="service-details-section-title">{title || t('serviceUi.details.keyFeatures')}</h3>
        <span aria-hidden="true">{features.length.toLocaleString()}</span>
      </div>
      <ul className="service-features-list">
        {features.map((feature, index) => (
          <li key={index} className="service-feature-item">
            <span className="feature-check" aria-hidden="true"><FiCheck /></span>
            <span className="feature-text">{feature}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ServiceFeatures;

